import {Button} from '@primer/react'
import {useRef, useState} from 'react'

import type {IPickerItem, MultiSelectPickerAnchorProps} from './types'

export function MultiSelectPickerAnchor<T extends IPickerItem>(props: MultiSelectPickerAnchorProps<T>) {
  const [isDialogOpen, setDialogOpen] = useState(Boolean(props.isOpenInitially))
  const openDialogButtonRef = useRef<HTMLButtonElement>(null)

  const {selected} = props
  const count = selected?.length
  const first = selected?.[0]
  const {
    itemConfig: {
      onRenderItemLeadingVisual,
      literals: {itemName, itemsName},
    },
  } = props

  return (
    <>
      <Button
        ref={openDialogButtonRef}
        onClick={() => setDialogOpen(true)}
        leadingVisual={
          first && onRenderItemLeadingVisual ? (onRenderItemLeadingVisual(first) as React.ReactElement) : null
        }
        aria-describedby={props['aria-describedby']}
      >
        {count ? `${count} ${count > 1 ? itemsName : itemName} selected` : `Select ${itemsName}`}
      </Button>
      {/* eslint-disable-next-line react-hooks/refs */}
      {isDialogOpen && props.renderDialog({onDismiss: () => setDialogOpen(false), returnFocusRef: openDialogButtonRef})}
    </>
  )
}

try{ MultiSelectPickerAnchor.displayName ||= 'MultiSelectPickerAnchor' } catch {}